/**
 * Logs Formik validation errors to console for debugging (captured by Hotjar)
 * @param componentName - The name of the component logging the error
 * @param formikContext - The Formik context containing errors and submitCount
 * @param requireSubmit - If true, only logs errors after form submission (submitCount > 0)
 */
export const logFormikValidationErrors = (componentName, formikContext, requireSubmit = false) => {
    const errors = formikContext === null || formikContext === void 0 ? void 0 : formikContext.errors;
    const submitCount = formikContext === null || formikContext === void 0 ? void 0 : formikContext.submitCount;
    const shouldLog = requireSubmit ? submitCount && submitCount > 0 : true;
    if (shouldLog && errors && Object.keys(errors).length > 0) {
        const logData = {
            errors,
            timestamp: new Date().toISOString(),
        };
        if (requireSubmit && submitCount) {
            logData.submitCount = submitCount;
        }
        console.error(`[${componentName}] Validation Errors:`, logData);
    }
};
